if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.redirectToCart = false; // Flag for Buy It Now behavior
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !this.redirectToCart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart || this.redirectToCart) {
              // Redirect to cart for Buy It Now or when no cart notification/drawer
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.redirectToCart = false; // Reset flag
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// Override Shopify's dynamic checkout buttons to redirect to cart immediately
document.addEventListener('DOMContentLoaded', function() {
  // Override Buy It Now button behavior
  function overrideBuyItNowButtons() {
    const shopifyPaymentButtons = document.querySelectorAll('.shopify-payment-button button, .dynamic-checkout__content button');
    
    shopifyPaymentButtons.forEach(button => {
      if (!button.hasAttribute('data-cart-redirect-override')) {
        button.setAttribute('data-cart-redirect-override', 'true');
        button.addEventListener('click', function(e) {
          // Prevent default Buy It Now checkout
          e.preventDefault();
          e.stopPropagation();
          
          // Find the associated product form
          const productForm = this.closest('product-form') || this.closest('.product-form') || document.querySelector('product-form');
          if (productForm) {
            // Set flag to redirect to cart immediately
            productForm.redirectToCart = true;
            const addToCartButton = productForm.querySelector('[name="add"]');
            if (addToCartButton && !addToCartButton.disabled) {
              addToCartButton.click();
            } else {
              // If no add button, just go to cart
              window.location.href = window.routes.cart_url;
            }
          } else {
            // Fallback - just go to cart
            window.location.href = window.routes.cart_url;
          }
        }, true);
      }
    });
  }
  
  // Initial override
  overrideBuyItNowButtons();
  
  // Monitor for dynamically added payment buttons
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // Check if any new payment buttons were added
        const hasPaymentButtons = Array.from(mutation.addedNodes).some(node => {
          return node.nodeType === 1 && (
            node.matches && node.matches('.shopify-payment-button, .dynamic-checkout__content') ||
            node.querySelector && node.querySelector('.shopify-payment-button button, .dynamic-checkout__content button')
          );
        });
        if (hasPaymentButtons) {
          overrideBuyItNowButtons();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Disable Shopify's payment button redirect
if (window.Shopify && window.Shopify.PaymentButton) {
  const originalInit = window.Shopify.PaymentButton.init;
  window.Shopify.PaymentButton.init = function() {
    // Call original init but override the redirect behavior
    const result = originalInit.apply(this, arguments);
    
    // Find all payment buttons and override their form action
    document.querySelectorAll('.shopify-payment-button form').forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        // Redirect to cart instead of checkout
        window.location.href = window.routes.cart_url;
      });
    });
    
    return result;
  };
}
